import styled from 'styled-components';

export const AnchorWrapper = styled.div`
    position: relative;
    width: 100%;
`;

export const Wrapper = styled.div`
    position: relative;
    display: none;

    &[data-ready='true'] {
        display: block;
    }
`;
